import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {DataService} from '../../service/data.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css', '../dialog.css']
})
export class DisclaimerComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dataService: DataService) {
  }

}
